import {Fragment, memo} from 'react'
import type {Row} from 'react-table'

import type {TableDataType} from '../../../components/react_table/table-data-type'
import type {ItemDataType} from '../../../components/react_table/use-item-data'
import type {GroupingMetadataWithSource} from '../../../features/grouping/types'
import {ViewerPrivileges} from '../../../helpers/viewer-privileges'
import {RoadmapItem} from './roadmap-item'
import {RoadmapOmnibarItem} from './roadmap-omnibar-item'

/**
 * Renders the collection of Roadmap items as rows
 */
export const RoadmapItems = memo(function RoadmapItems({
  groupMetadata,
  groupId,
  rows,
  isOmnibarFixed,
  itemData,
}: {
  groupMetadata?: GroupingMetadataWithSource
  groupId?: string
  rows: Array<Row<TableDataType>>
  isOmnibarFixed: boolean
  itemData: ItemDataType
}) {
  const {hasWritePermissions} = ViewerPrivileges()

  return (
    <Fragment>
      {rows.map(row => {
        return <RoadmapItem key={row.original.id} row={row} itemData={itemData} />
      })}
      {hasWritePermissions && !isOmnibarFixed && (
        <RoadmapOmnibarItem groupMetadata={groupMetadata} groupRows={rows} groupId={groupId} />
      )}
    </Fragment>
  )
})

try{ RoadmapItems.displayName ||= 'RoadmapItems' } catch {}